import React from "react";
import { useSettings } from "../SettingsContext";

export default function WhatsAppButton() {
  const { settings } = useSettings();
  const wa = settings.whatsapp_e164 || "221781130516";
  const text = encodeURIComponent("Bonjour Queensway Studio, j'aimerais des informations / Hello Queensway Studio, I'd like more info.");
  const href = `https://wa.me/${wa}?text=${text}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-28 z-50 h-16 w-16 flex items-center justify-center bg-[#25D366] text-white shadow-2xl border border-[#25D366] hover:scale-110 transition-transform duration-300"
      style={{ boxShadow: "0 12px 40px -8px rgba(37,211,102,0.45)" }}
    >
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.21c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.28-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.15-.42-2.19-1.35-.81-.72-1.36-1.62-1.51-1.89-.16-.28-.02-.43.12-.57.13-.12.27-.32.41-.48.14-.16.18-.28.27-.46.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.02-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.28-.95.93-.95 2.27 0 1.34.98 2.63 1.12 2.81.14.18 1.93 2.95 4.68 4.13.65.28 1.16.45 1.55.58.65.21 1.24.18 1.71.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32zM16.02 4.4c-6.4 0-11.6 5.2-11.6 11.6 0 2.04.53 4.04 1.54 5.8L4.4 27.6l5.97-1.56a11.6 11.6 0 0 0 5.65 1.46h.01c6.4 0 11.6-5.2 11.6-11.6 0-3.1-1.21-6.02-3.4-8.21A11.55 11.55 0 0 0 16.02 4.4zm0 21.27h-.01a9.66 9.66 0 0 1-4.92-1.35l-.35-.21-3.54.93.95-3.45-.23-.36a9.65 9.65 0 0 1-1.48-5.13c0-5.33 4.34-9.67 9.68-9.67a9.6 9.6 0 0 1 6.83 2.83 9.6 9.6 0 0 1 2.83 6.84c0 5.34-4.34 9.67-9.76 9.67z" />
      </svg>
    </a>
  );
}
